export class Step2 {
    constructor() {}

    public getobjet = 'form.dive_at.getobjet';
    public getvaleurtotaleestimee = 'form.dive_at.getvaleurtotaleestimee';
    public getdevise = 'form.dive_at.getdevise';
    public getdateattribution = 'form.dive_at.getdateattribution';
    public getprocedure = 'form.dive_at.getprocedure';
    public getinfructueux = 'form.dive_at.getinfructueux';
    public getsanssuite = 'form.dive_at.getsanssuite';
    public getattribueunique = 'form.dive_at.getattribueunique';
    public getattribueparlots = 'form.dive_at.getattribueparlots';
    public getlotsinfructueux = 'form.dive_at.getlotsinfructueux';
    public getspan4 = 'form.dive_at.getspan4';

}
